import { repositories } from "@/core";
import { required } from "vuelidate/lib/validators";
import { mapActions } from "vuex";

export default {
  name: "EditAdmins",
  mounted() {
    this.loadingItems = true;
    this.getData();
  },
  data() {
    return {
      item: {},
      errorMessage: "",
      submitting: false,
      id: this.$route.params.id,
      form: {
        name: "",
      },
    };
  },
  validations: {
    form: {
      name: {
        required,
        // email,
      },
    },
  },
  methods: {
    ...mapActions(["syncSessionWithApi"]),
    async getData() {
      try {
        const res = await repositories.userService.show(this.id);
        let data = res.data;
        this.$set(this, "form", { name: data.name });
        this.$set(this, "item", data);
      } catch (e) {
        console.log(e);
      } finally {
        this.loadingItems = false;
      }
    },
    async submit() {
      try {
        this.submitting = true;
        this.errorMessage = "";
        const values = this.form;
        const res = await repositories.userService.update(this.id, values);
        if (this.id == this.$store.state.userSession.id) {
          console.log("ENTREI");
          console.log(res);
          this.syncSessionWithApi(res.data);
        }
        this.$eventBus.$emit("showToast", {
          title: "Admin alterado",
          msg: `Admin alterado com sucesso`,
        });
        this.$router.back();
      } catch (e) {
        this.errorMessage = e.message;
      } finally {
        this.submitting = false;
      }
    },
  },
};
